import reducers, { getScheduledReducers } from 'app/reducers';
import reducersV2 from 'app/reducers-v2';
import { applyMiddleware, combineReducers, compose, createStore as createReduxStore } from 'redux';
import thunk from 'redux-thunk';

export default function createStore() {
  const dynamicReducers = getScheduledReducers();

  function createReducer() {
    const appReducers = combineReducers({
      ...reducers,
      ...dynamicReducers,
      v2: reducersV2,
    });

    return (state, action) => {
      if (action.type === 'USER_LOGOUT') {
        return appReducers(undefined, action);
      }
      return appReducers(state, action);
    };
  }

  const store = compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )(createReduxStore)(createReducer());

  /**
   * As per http://stackoverflow.com/questions/32968016/how-to-dynamically-load-reducers-for-code-splitting-in-a-redux-application,
   * this seems to be the preferred way to dynamically load reducers
   */
  store.injectReducer = function injectReducer(name, reducer) {
    dynamicReducers[name] = reducer;
    store.replaceReducer(createReducer());
  };

  return store;
}
